import React from 'react';
import PropTypes from 'prop-types';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import AttachmentsContentPicker
  from 'Components/Modals/IdentityVerificationReviewDetails/reviewDetailsContent/attachmentsContent/AttachmentsContentPicker';
import ResultsContent
  from 'Components/Modals/IdentityVerificationReviewDetails/reviewDetailsContent/resultsContent/ResultsContent';
import FooterPicker from 'Components/Modals/IdentityVerificationReviewDetails/reviewDetailsContent/footer/FooterPicker';

const styles = (theme) => ({
  root: {
    display: 'grid',
    gridTemplateRows: 'auto',
    gridTemplateColumns: '1fr 1fr',
    height: '100%',
  },
  contentContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  commentContainer: {
    display: 'flex',
    width: '100%',
  },
  multiColumn: {
    gridColumn: 'span 2',
  },
  header: {
    fontWeight: theme.typography.fontWeightBold,
    paddingBottom: theme.spacing(2),
  },
});

const IdentityVerificationReviewDetailsLayout = ({
  classes,
  onDecisionMade,
  onReopen,
}) => {
  const {
    resource,
    inlineSubmit,
  } = useMetaLayoutContext();

  return (
    <Box
      className={classes.root}
    >
      <Typography variant={'h3'} color={'primary'} className={classes.header}>
        {'Funding Account Details'}
      </Typography>
      <Typography variant={'h3'} color={'primary'} className={classes.header}>
        {'Facet Account Details'}
      </Typography>

      <MetaField attr="bankAccountName" className={classes.text} />
      <MetaField attr="clearingHouseAccountName" className={classes.text} />

      <MetaField attr="bankAccountRoutingNumber" />
      <MetaField attr="clearingHouseAccountNumber" />

      <MetaField attr="bankAccountNumber" />
      <MetaField attr="assignedTo" onChange={inlineSubmit} />

      <div className={classes.multiColumn}>
        <ResultsContent resource={resource} />
      </div>

      <div className={classes.multiColumn}>
        <AttachmentsContentPicker resource={resource} />
      </div>

      <div className={classes.multiColumn}>
        <MetaField attr="reviewComment" />
      </div>
      <div className={classes.multiColumn}>
        <FooterPicker resource={resource} onDecisionMade={onDecisionMade} onReopen={onReopen} />
      </div>
    </Box>
  );
};

IdentityVerificationReviewDetailsLayout.defaultProps = {};

IdentityVerificationReviewDetailsLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  onDecisionMade: PropTypes.func.isRequired,
  onReopen: PropTypes.func.isRequired,
};

export default withStyles(styles)(IdentityVerificationReviewDetailsLayout);
